import { defineMessages } from "react-intl";

export const messages = defineMessages({
  openAiHome: {
    id: "landing.navigation.openai_home",
    defaultMessage: "OpenAI Home",
    description: "Accessible label for the OpenAI home link on the public Ads landing page.",
  },
  copyright: {
    id: "landing.footer.copyright",
    defaultMessage: "OpenAI © {year}",
    description: "Copyright notice in the public Ads landing page footer.",
  },
  language: {
    id: "landing.navigation.language",
    defaultMessage: "Language",
    description: "Accessible label for the language selector on the public Ads landing page.",
  },
  logIn: {
    id: "landing.navigation.log_in",
    defaultMessage: "Log in",
    description: "Action for logging in from the public Ads landing page.",
  },
  signUp: {
    id: "landing.navigation.sign_up",
    defaultMessage: "Sign up",
    description: "Action for signing up from the public Ads landing page.",
  },
  metaDescription: {
    id: "landing.meta.description",
    defaultMessage:
      "Reach people as they explore options, compare choices, and make decisions in ChatGPT, with relevant ads that fit naturally into the experience.",
    description: "Search and social description for the public Ads landing page.",
  },
  metaTitle: {
    id: "landing.meta.title",
    defaultMessage: "Advertise in ChatGPT | OpenAI Ads",
    description: "Search and social title for the public Ads landing page.",
  },
});
